import { create } from 'zustand';

export const useWorkflowTaskStore = create((set) => ({
    items: [],
    inbox: [],
    loading: false,
    error: null,

    setItems: (items) => set({ items }),
    setInbox: (inbox) => set({ inbox }),
    setLoading: (loading) => set({ loading }),
    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),
}));
